import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';
import { WithTabTitle } from '../../../../common/widgets/withTabTitle';
import AdminAccount from '../../Pages/AdminAccount';
import CompaniesSettingsPage from '../../Pages/AdminAccount/CompaniesSettingsPage';
import EmployeesFilesPage from '../../Pages/AdminAccount/EmployeesFilesPage';
import FinalReportPage from '../../Pages/AdminAccount/FinalReportsPage';
import GeneralStatisticsPage from '../../Pages/AdminAccount/GeneralStatisticsPage';
import ImportCardsPage from '../../Pages/AdminAccount/ImportCardsPage';
import ImportOrdersPage from '../../Pages/AdminAccount/ImportOrdersPage';
import ImportTimesheetPage from '../../Pages/AdminAccount/ImportTimesheetPage';
import { resources } from '../../resources/resources';
import { EmployeeBenefitsRoutes } from './EmployeeBenefits';
import { EmployeeAdminRoutes } from './EmployeesAdmin';
import { TimeAndAttendanceAdminRoutes } from './TimeAndAttendanceAdmin';
import DownloadFromLinkPage from '../../Pages/AdminAccount/EmployeesFilesPage/Components/DownloadFromLinkPage';

export const AdminAccountRoutes = () => {
  const { t: translate } = useTranslation();
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WithTabTitle title={translate(resources.menu.admin)}>
            <AdminAccount />
          </WithTabTitle>
        }
      >
        <Route
          path="employee-management/*"
          element={
            <WithTabTitle title={translate(resources.admin.employees.title)}>
              <EmployeeAdminRoutes />
            </WithTabTitle>
          }
        />
        <Route
          path="cards-import"
          element={
            <WithTabTitle title={translate(resources.admin.importCards.title)}>
              <ImportCardsPage />
            </WithTabTitle>
          }
        />
        <Route
          path="orders-import"
          element={
            <WithTabTitle title={translate(resources.admin.importOrders.title)}>
              <ImportOrdersPage />
            </WithTabTitle>
          }
        />
        <Route
          path="timesheets-import/*"
          element={
            <WithTabTitle
              title={translate(resources.admin.importTimesheets.title)}
            >
              <div>
                <ImportTimesheetPage />
              </div>
            </WithTabTitle>
          }
        />
        <Route
          path="attendance/*"
          element={
            <WithTabTitle title={translate(resources.menu.attendance)}>
              <TimeAndAttendanceAdminRoutes />
            </WithTabTitle>
          }
        />
        <Route
          path="employee-benefits/*"
          element={<EmployeeBenefitsRoutes />}
        />
        <Route
          path="companies-settings"
          element={
            <WithTabTitle title={translate(resources.admin.companies.title)}>
              <CompaniesSettingsPage />
            </WithTabTitle>
          }
        />

        <Route
          path="final-reports"
          element={
            <WithTabTitle title={translate(resources.admin.finalReport.title)}>
              <FinalReportPage />
            </WithTabTitle>
          }
        />
        <Route
          path="general-statistics"
          element={
            <WithTabTitle title={translate(resources.admin.statistics.title)}>
              <GeneralStatisticsPage />
            </WithTabTitle>
          }
        />
        <Route
          path="employee-files"
          element={
            <WithTabTitle
              title={translate(resources.admin.employeesFiles.title)}
            >
              <EmployeesFilesPage />
            </WithTabTitle>
          }
        />
        <Route
          path="employee-files/download"
          element={
            <WithTabTitle
              title={translate(resources.admin.employeesFiles.title)}
            >
              <DownloadFromLinkPage />
            </WithTabTitle>
          }
        />
        <Route path="*" element={<Navigate to="/*" />} />
      </Route>
    </Routes>
  );
};
